<template>
  <ons-page id="login">
    <v-ons-progress-bar indeterminate class="page-progress" v-show="loading"></v-ons-progress-bar>
    <div class="center-box full-height">
      <form action="" class="login-content login-form">
        <div class="tabs tabs-login tabs-round tabbar tabbar--top" data-control="#tabs-content-login">
          <label class="tabbar__item" data-index="1">
          <input type="radio" name="tab-login" checked="checked">
          <button class="tabbar__button">
            {{ $t("login.nav.sso") }}
          </button>
          </label>
          <label class="tabbar__item" data-index="2">
          <input type="radio" name="tab-login" >
          <button class="tabbar__button">
            {{ $t("login.nav.email") }}
          </button>
          </label>
        </div>
        <div class="tabs-slider tabs-slider-2" id="tabs-content-login">
          <div>
            <ul class="no-bullet">
              <li>
                <ons-button class="facebook" modifier="large"
                  :disabled="loading"
                  @click="signInOrSignUpWith('Facebook')"
                >
                  <span class="icon-sm">
                    <icon-facebook />
                  </span>
                  {{ $t("login.login_with_fb") }}
                </ons-button>
              </li>
              <li>
                <v-ons-button class="google" modifier="large"
                  :disabled="loading"
                  @click="signInOrSignUpWith('Google')"
                >
                  <span class="icon-sm">
                    <icon-google />
                  </span>
                  {{ $t("login.login_with_google") }}
                </v-ons-button>
              </li>
              <li v-show="!$isStandalone || isIOS">
                <ons-button class="apple" modifier="large"
                  :disabled="loading"
                  @click="signInOrSignUpWith('Apple')"
                >
                  <span class="icon-sm">
                    <icon-apple />
                  </span>
                  {{ $t("login.login_with_apple") }}
                 </ons-button>
              </li>
              <li v-if="canGoOffline">
                <v-ons-button modifier="large--quiet"
                  :disabled="loading"
                  @click="goOffline"
                >
                  {{ $t("login.go_offline") }}
                </v-ons-button>
              </li>
            </ul>
          </div>
          <div>
            <div class="form-group">
              <div class="form-row">
                <v-ons-input id="email" type="email" modifier="underbar" :placeholder="$t('login.email')" float
                  v-model="email"
                />
              </div>
              <div class="form-row">
                <v-ons-input id="password" modifier="underbar" type="password" :placeholder="$t('login.password')" float
                  v-model="password"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="form-row center-align">
                <v-ons-button class="login-submit" modifier="large"
                  :disabled="loading"
                  @click="signIn()"
                >{{ $t("login.login") }}</v-ons-button>
              </div>
              <div class="justify-row small">
                <div class="main-item">
                  <a class="button--quiet button--small js-newpage" @click.prevent="navigatorPush('ForgetPassword', {}, { animation: 'lift'})" modifier="quiet small" href="">{{ $t("login.forget_pw") }}</a>
                </div>
                <div>
                  <a class="link-register button--quiet button--small js-newpage" @click.prevent="navigatorPush('Signup', { allowPop: allowPop }, { animation: 'lift' })" modifier="quiet small" href="">{{ $t("login.signup") }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="small center-align" v-if="allowPop">
          <a class="button--quiet button--small" @click.prevent="navigatorPop()" modifier="quiet small" href="">{{ $t("ui.back") }}</a>
        </div>
        <div class="small center-align" v-else-if="!$requireLogin">
          <a class="button--quiet button--small" @click.prevent="signInAsGuest()" modifier="quiet small" href="">{{ $t("login.skip") }}</a>
        </div>
      </form>
    </div>
  </ons-page>
</template>

<script>
import SignInOrSignUpWith from '@/mixins/SignInOrSignUpWith';

export default {
  name: 'login',
  props: ['pageParamsAfterLoad', 'allowPop'],
  mixins: [SignInOrSignUpWith],

  data() {
    return {
      email: null,
      password: null,
      loading: false,
      isIOS: this.$ons.platform.isIOS() || this.$ons.platform.isIPadOS(),
      canGoOffline: !!window.cordova && !!window.localStorage.getItem('token'),
    };
  },

  computed: {
    pageParamsAfterLogin() {
      if (!this.pageParamsAfterLoad) { return null; }
      if (this.pageParamsAfterLoad.initFrom !== 'main-tarbar') { return null; }
      return this.pageParamsAfterLoad;
    },
  },

  methods: {
    signIn() {
      let that = this;
      this.loading = true;
      // somehow the input value may not be captured in the model when tested by a app store reviewer
      let email = this.email;
      let password = this.password;
      let emailEl = this.$el.querySelector('#email');
      let passwordEl = this.$el.querySelector('#password');
      if (emailEl && emailEl.value) { email = emailEl.value; }
      if (passwordEl && passwordEl.value) { password = passwordEl.value; }
      this.$store.dispatch('currentUser/signIn', { email: email, password: password })
        .then(() => {
          if (!this.allowPop) {
            this.navigatorResetMain({ pageParamsAfterLoad: this.pageParamsAfterLogin } || {});
          } else {
            this.navigatorPop();
          }
          this.setupPushNotification();
        }).catch((error) => {
          if (error.message && error.message.indexOf('authorization') !== -1) {
            that.$ons.notification.toast(that.$t("messages.invalid_cred"), { timeout: 1500, animation: 'fall' });
          } else {
            console.log(error);
            that.showSomethingWrongToast();
          }
        }).finally(() => {
          this.loading = false;
        });
    },
    signInAsGuest() {
      this.$store.dispatch('currentUser/signInAsGuest').then(() => {
        this.navigatorResetMain();
      });
    },
  },

  mounted() {
    if (this.pageParamsAfterLoad && this.pageParamsAfterLoad.page !== 'Login' && (this.pageParamsAfterLoad.initFrom === 'login' || this.pageParamsAfterLoad.initFrom === 'any')) {
      this.navigatorPush(this.pageParamsAfterLoad.page, this.pageParamsAfterLoad.props || {}, this.pageParamsAfterLoad.options || {});
    }
    this.loadTabs(this.$el);
  },
};
</script>
